export default function scroll() {
  window.onload = () => {
    if (window.location.hash.includes('#gebetszeiten')) {
      document.getElementById('gebetszeiten')?.scrollIntoView();
    }
  };
}
